// src/branding.js

const BRANDS = {
  tmta: {
    organizationName: "Texas Music Teachers Association",
    shortName: "TMTA",
    logo: "/tmta-logo.png",
    favicon: "/tmta-favicon.ico",
    pageTitle: "TMTA Online Theory Exams",
    examSubtitle: "Online Theory & World of Music Exams",
    footer: "© Texas Music Teachers Association"
  },

  ismta: {
    organizationName: "Illinois State Music Teachers Association",
    shortName: "ISMTA",
    logo: "/ismta-logo.png",
    favicon: "/ismta-favicon.ico",
    pageTitle: "ISMTA Online Theory Exams",
    examSubtitle: "Online Achievement in Music Exams",
    footer: "© Illinois State Music Teachers Association"
  }
};

export function getBrand() {
  const hostname =
    typeof window !== "undefined"
      ? window.location.hostname.toLowerCase()
      : "";

  if (
    hostname === "ismta.liontheory.com" ||
    hostname.startsWith("ismta.")
  ) {
    return BRANDS.ismta;
  }

  return BRANDS.tmta;
}

export function applyBrandToDocument(brand) {
  document.title = brand.pageTitle;

  let favicon = document.querySelector(
    'link[rel="icon"]'
  );

  if (!favicon) {
    favicon = document.createElement("link");
    favicon.rel = "icon";
    document.head.appendChild(favicon);
  }

  favicon.href = brand.favicon;
}